import * as Yup from 'yup';
import moment from 'moment';

import { AGREEMENT_CONSENT_REQUIRED_ERROR_MESSAGE } from './constants';

const REQUIRED_CONSENT_FIELD = Yup.boolean().oneOf(
  [true],
  AGREEMENT_CONSENT_REQUIRED_ERROR_MESSAGE,
);

export const AGREEMENT_FORM_SCHEMA = Yup.object({
  consent_electronic_delivery_via_email: REQUIRED_CONSENT_FIELD,
  consent_text_messages_regarding_aba_services: REQUIRED_CONSENT_FIELD,
  consent_electronic_signature_platform: REQUIRED_CONSENT_FIELD,
  consent_complete_required_assessments: REQUIRED_CONSENT_FIELD,
  consent_paper_document_delivery_notice: REQUIRED_CONSENT_FIELD,
  consent_electronic_delivery_freely_given: REQUIRED_CONSENT_FIELD,
  printed_name: Yup.string().required('Required'),
  signature: Yup.string().required('Required'),
  signature_date: Yup.mixed()
    .test(
      'is-moment-or-null',
      'Invalid date',
      (value) => value === null || (moment.isMoment(value) && value.isValid()),
    )
    .required('Required'),
});
